// variables
import { ALL_HIDDEN, MAIN_OBJECT } from 'variables';

/**
 * 동코드를 한글로 변경하는 함수
 */
export const buildingNumberToKor = (buildingCode) => {
  if (!buildingCode) return '';

  if (buildingCode === 'Basement') return '지하';

  const number = buildingCode.replace(/[^0-9]/g, '');

  if (!number) return buildingCode;

  const formattedNumber = number.startsWith('0') ? parseInt(number) : number;

  return formattedNumber === 0 ? '공용' : `${formattedNumber}동`;
};

/**
 * 층코드를 한글로 변경하는 함수
 */
export const floorNumberToKor = (floorCode) => {
  if (!floorCode) return '';

  if (floorCode === 'F00') return '지상층';

  if (floorCode === 'RF' || floorCode === '옥상') return '옥상';

  if (floorCode === MAIN_OBJECT || floorCode === '전체') return '전체';

  if (floorCode === ALL_HIDDEN || floorCode === '숨김') return '숨김';

  if (floorCode === 'G00' || floorCode === 'Ground') return '지상';

  if (floorCode === 'G01' || floorCode === 'Fence') return '펜스';

  const number = floorCode.replace(/[^0-9]/g, '');

  if (!number) return floorCode;

  const formattedNumber = number.startsWith('0') ? parseInt(number) : number;

  if (floorCode.startsWith('B')) {
    return `지하${formattedNumber}층`;
  } else if (floorCode.startsWith('F')) {
    return `${formattedNumber}층`;
  }

  return `${formattedNumber}층`;
};

/**
 * 대괄호 안의 텍스트 추출
 */
export const getAssessmentType = (header) => {
  const match = header.match(/\[(.*?)\]/);

  return match ? match[1].slice(0, 2) : '';
};

/**
 * 일자가 한자리수일 경우 앞에 0을 붙이는 함수
 */
export const addZeroDate = (date) => (String(date).length > 1 ? date : `0${date}`);

/**
 * F 번호 추출 함수
 */
export const extractFNumber = (text) => {
  // _Floor 또는 _FLOOR suffix 제거
  const cleanedText = text.replace(/_Floor$/i, '');

  const fPart = cleanedText.includes('F') ? 'F' : cleanedText.includes('B') ? 'B' : '';

  if (cleanedText.includes('RF')) {
    return 'RF';
  }

  if (!fPart) {
    // F나 B가 없는 특수 층(PIT, L, Lobby 등)은 정리된 텍스트 반환
    return cleanedText;
  }

  const match = cleanedText.match(/[FB](\d+)/);

  if (!match) return cleanedText;

  const numberPart = match[1].padStart(2, '0').slice(0, 2);

  return fPart + numberPart;
};

export const formatRoomName = (structureCode, isBundang = false) => {
  if (!structureCode) return '';

  const { buildingCode, floorCode, structureNameKo } = structureCode;

  if (isBundang) {
    return `309동 ${floorCode} ${structureNameKo}`;
  }

  return `${buildingNumberToKor(buildingCode)} ${floorNumberToKor(floorCode)} ${structureNameKo || ''}`;
};

export const extractDummyModelName = (name) => {
  if (!name) return '';

  const parts = name.split('_');

  if (parts.length >= 3) {
    return parts.slice(2).join('_');
  }

  return '';
};
